import type { TranscriptionResponse } from "@ui/components/demos/STT/types";

import { getCaptchaToken } from "@/app/_providers/hcaptcha/core";
import { generateStt, STT_ERROR_MAP, type ErrorCode } from "@/app/_api/generateStt";

export type SttTranscribeError = ErrorCode | "transcribe_failed" | "aborted";

export async function transcribeSttFile({
  file,
  signal,
  diarize = true,
  tag_audio_events = true,
  language_code = null,
  with_additional_formats = true,
}: {
  file: File;
  signal?: AbortSignal;
  diarize?: boolean;
  tag_audio_events?: boolean;
  language_code?: string | null;
  with_additional_formats?: boolean;
}): Promise<[error: SttTranscribeError | null, result: TranscriptionResponse | null]> {
  try {
    const token = await getCaptchaToken({ behaviourType: "stt" });
    const res = await generateStt({
      file,
      signal,
      hcaptcha_token: token,
      diarize,
      tag_audio_events,
      language_code,
      with_additional_formats,
    });
    return [null, res];
  } catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") {
      return ["aborted", null];
    }
    if (
      typeof error === "object" &&
      error !== null &&
      "status" in error &&
      (error as { status: string }).status in STT_ERROR_MAP
    ) {
      return [(error as { status: ErrorCode }).status, null];
    }
    return ["transcribe_failed", null];
  }
}
